import React from 'react';

export default function LoadingSpinner({ size = 36, color = 'var(--primary)', fullPage = false }) {
  const spinner = (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: '3px solid var(--border)',
        borderTopColor: color,
        animation: 'spin 0.7s linear infinite',
        flexShrink: 0,
      }}
    />
  );

  if (fullPage) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255,255,255,0.95)',
          zIndex: 9000,
          gap: 16,
        }}
      >
        {spinner}
        <span style={{ color: 'var(--text-tertiary)', fontSize: 14, fontWeight: 500 }}>
          잠시만 기다려주세요...
        </span>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 40,
      }}
    >
      {spinner}
    </div>
  );
}
